// @flow

import React, { Component } from 'react';
import { Row, Button, Image } from 'react-bootstrap/lib';
import styler from 'react-styling';

import MeetingroomBusyStatus from './MeetingroomBusyStatus';
import MeetingroomAvailableStatus from './MeetingroomAvailableStatus';
import logo from '../../../img/symfoni_logo.png';

import { getEventStatus } from '../../libs/Extract';

const style = styler `
  HeaderContainer
    text-align: center
  HeaderText
    font-size: 45px
    color: #FFF
  StatusContainer
    margin: 50px auto
    text-align: center
    height: 43vw
    width: 43vw
    max-width: 65vh
    max-height: 65vh
    border-radius: 50%
  NextMeetingContainer
    margin-top: 0.5 vw
    color: #F5F5F5
`;

const footerStyle = styler `
  Container
    text-align: center
  Logo
    position: absolute
    right: 0
    bottom: 15px
  LogoImg
    width: 10vw
  EndMeetingBtn
    color: #ECECEC
    background-color: #182B56
    border-radius: 0px
    border: none
    padding: 15px 20px
`;

const MeetingroomStatusFooter = (props: { clock: Object, nextEvent: Object, getNextMeetingTime: Function, busy: boolean, onEndMeeting: Function, lang: Object }) => {
  const { busy, onEndMeeting, lang, nextEvent, clock, getNextMeetingTime } = props;
  return (
    <div style={footerStyle.Container}>
      { busy ? (<Button onClick={onEndMeeting} style={footerStyle.EndMeetingBtn}>{lang.end_meeting}</Button>)
      : nextEvent ?
        (<Row style={style.NextMeetingContainer}>
          {lang.next_meeting_starts} {getNextMeetingTime(nextEvent, clock)}
        </Row>)
        : null
      }
      <div style={footerStyle.Logo}>
        <Image style={footerStyle.LogoImg} src={logo} alt="Logo" />
      </div>
    </div>
  );
};


class MeetingroomStatus extends Component {

  _getNextMeetingTime = (nextEvent: Object, now: Object) => nextEvent.start.from(now);

  props: {
    show: boolean,
    meetingroom: Object,
    events: Array<Object>,
    viewer: Object,
    clock: Object,
    lang: Object,
    onEndMeeting: Function,
    onBook: Function,
    nextEvent?: Object,
  };

  render() {
    const { meetingroom, show, events, clock, onEndMeeting, lang, viewer, onBook } = this.props;
    const displayName = meetingroom.displayName ? meetingroom.displayName : null;
    const { current, next } = getEventStatus(events, clock);
    return (
      <div>
        <Row style={style.HeaderContainer}>
          <span style={style.HeaderText}>{displayName}</span>
        </Row>
        <Row style={style.StatusContainer}>
          {
            current ?
            (
              <MeetingroomBusyStatus
                event={current}
                clock={clock}
              />
            ) :
            (
              <MeetingroomAvailableStatus
                clock={clock}
                meetingroom={meetingroom}
                nextEvent={next}
                viewer={viewer}
                lang={lang}
                show={show}
                onBook={onBook}
              />
            )
          }
        </Row>
        <Row>
          <MeetingroomStatusFooter
            busy={current !== null}
            onEndMeeting={() => onEndMeeting(current)}
            lang={lang}
            clock={clock}
            nextEvent={next}
            getNextMeetingTime={this._getNextMeetingTime}
          />
        </Row>
      </div>
    );
  }

}

export default MeetingroomStatus;



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingroomStatus.js